import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { searchContextStore } from '../search/SearchContextProvider';
import { translate, getVisibleFilters } from '../searchHelpers';

/** filters the active filters out ot the current context. */
function filtersActive(context) {
  const filters = getVisibleFilters(context.searchConfig.filters).filter(
    (filter) => {
      if (filter.name in context.searchParams) {
        return context.searchParams[filter.name] !== 'all';
      }
    },
  );
  return filters.length;
}

const NoResults = ({ styleModifier }) => {
  const { state: searchContext } = useContext(searchContextStore);

  const _t = translate.bind(
    null,
    searchContext.searchConfig,
    searchContext.translations,
  );

  const message = _t(
    filtersActive(searchContext)
      ? 'noResultsForSearchtermFiltersActive'
      : 'noResultsForSearchterm',
  );

  return (
    <div
      className={classNames('search-no-results', styleModifier)}
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
};

NoResults.propTypes = {
  styleModifier: PropTypes.string,
};

export default NoResults;
